import { Component, OnInit } from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {OverlayConfig, OverlayRef} from 'exc-controls';

@Component({
  selector: 'app-provider-modal-disposition-batch',
  templateUrl: './provider-modal-disposition-batch.component.html',
  styles: []
})
export class ProviderModalDispositionBatchComponent extends ExcTranslation implements OnInit {

  auditList: any[] = [];
  auditorList: any[] = [];
  constructor(private overlayConfig: OverlayConfig, private overlayRef: OverlayRef) {
    super();
  }

  ngOnInit() {
    for (const x of this.overlayConfig.data.Auditors) {
      this.auditorList.push(Object.assign({}, x));
    }
    for (const x of this.overlayConfig.data.Audits) {
      const a = Object.assign({}, x);
      a['PrimaryAuditor'] = null;
      this.auditList.push(a);
    }
  }
  isNextDisabled() {
    for (const a of this.auditList) {
      if (a['PrimaryAuditor'] === null) {
        return true;
      }
    }
    return false;
  }
  proceed(success: boolean) {
    if (success) {
      const root = [];
      for (const a of this.auditList) {
        const _a = {};
        _a['AuditID'] = a.AuditID;
        _a['PrimaryAuditor'] = a.PrimaryAuditor;
        _a['AdditionalAuditors'] = [];
        for (const ad of this.auditorList) {
          if (ad.AdmID.toString() !== a.PrimaryAuditor.toString()) {
            _a['AdditionalAuditors'].push(ad.AdmID);
          }
        }
        root.push(_a);
      }
      this.overlayRef.close({Proceed: true, AuditData: JSON.stringify(root)});
     } else {
      this.overlayRef.close({Proceed: false, AuditData: null});
    }

  }
}
